/**
 * Hub follows the basic setup of the @amplify/core hub to ensure easy use from the client side
 */
export interface Hub<TPayload extends Payload = Payload> {
  listen: (channel: string, handler: ListenHandler) => void;
  remove: (channel: string, handler: RemoveHandler) => void;
  dispatch: (channel: string, capsule: TPayload) => void;
}

type ListenHandler = (capsule: HubCapsule) => void;
type RemoveHandler = (capsule: HubCapsule) => void;

export interface HubCapsule<TPayload extends Payload = Payload> {
  channel: string;
  payload: TPayload;
}

export interface Payload {
  event: string;
}
